var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItemChatIconFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#add8e6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.43,20.94a5.6,5.6,0,0,1,.05-.6A14,14,0,0,0,14,0h-.48A14,14,0,0,0,0,14.47,13.94,13.94,0,0,0,14,28h.48a13.49,13.49,0,0,0,3.28-.52c.42,0,.77-.11,1.11-.18a7.76,7.76,0,0,1,1.72-.2,11.63,11.63,0,0,1,3.56.67l.37.11A1.85,1.85,0,0,0,25,28h0a2.09,2.09,0,0,0,1.21-.36A2.14,2.14,0,0,0,27.08,26a1.36,1.36,0,0,0,0-.41A21.71,21.71,0,0,1,26.43,20.94Zm-6.14-1.09H17.41l0-1a5.39,5.39,0,0,1-3.48,1.24c-3.76,0-6.19-2.37-6.19-6s2.53-6.1,6.29-6.1,6.29,2.45,6.29,6.1Zm-6.18-9A3,3,0,0,0,11,14a3,3,0,0,0,3.16,3.21,3.15,3.15,0,0,0,3.13-2.43c0-.12,0-.72,0-.78A3,3,0,0,0,14.11,10.83Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemChatIconFill);
export default __webpack_public_path__ + "static/media/item_chat_icon_fill.b7341b2d7c8cf787417e49aa526dee16.svg";
export { ForwardRef as ReactComponent };